import React from "react";
import { Reveal, SectionHeading } from "./_shared";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../ui/accordion";

const items = [
    {
        q: "Che cos'è SafetyDesk81 e cosa lo rende diverso dagli altri scadenzari?",
        a: "SafetyDesk81 non è un semplice scadenzario. Riunisce in un'unica piattaforma adempimenti, formazione, visite mediche, sopralluoghi, documenti e registri digitali. Il chatbot e l'agente AI permettono inoltre di consultare più facilmente le informazioni e supportano l'azienda nella gestione quotidiana. L'obiettivo è eliminare i registri cartacei e avere tutto sotto controllo in un unico ambiente digitale.",
    },
    {
        q: "A chi è rivolto l'evento?",
        a: "L'evento è rivolto esclusivamente alle aziende, agli imprenditori, ai responsabili aziendali e ai referenti interni che desiderano semplificare e digitalizzare la gestione della sicurezza e degli adempimenti.",
    },
    {
        q: "Durante l'evento sarà mostrata la piattaforma?",
        a: "Sì. Durante l'evento del 1° ottobre 2026 verranno mostrate dal vivo le principali funzionalità di SafetyDesk81, compresi il chatbot AI e la gestione dei registri digitali.",
    },
    {
        q: "L'iscrizione crea un account SafetyDesk81?",
        a: "No. L'iscrizione all'evento non comporta la creazione di un account sulla piattaforma.",
    },
    {
        q: "Quando è previsto il lancio ufficiale dell'applicazione?",
        a: "Il lancio ufficiale di SafetyDesk81 è previsto entro la fine del 2026. Durante l'evento del 1° ottobre sarà presentata in anteprima la piattaforma e saranno illustrate le sue principali funzionalità.",
    },
    {
        q: "Posso partecipare anche se non sono ancora cliente?",
        a: "Sì. L'evento è pensato anche per aziende che desiderano conoscere SafetyDesk81 e valutare come digitalizzare la gestione degli adempimenti.",
    },
];

export default function FAQ() {
    return (
        <section id="faq" className="py-24 md:py-32 bg-white">
            <div className="max-w-[1000px] mx-auto px-5 md:px-8">
                <SectionHeading chapter={10} chapterLabel="FAQ" title="Domande frequenti." />
                <Reveal delay={0.15}>
                    <div className="mt-12">
                        <Accordion type="single" collapsible className="w-full">
                            {items.map((it, i) => (
                                <AccordionItem key={i} value={`item-${i}`} className="border-b border-navy-100 py-2" data-testid={`faq-${i}`}>
                                    <AccordionTrigger className="text-navy-950 font-display font-semibold text-lg md:text-xl py-5 hover:no-underline">
                                        <span className="flex items-center gap-4 text-left">
                                            <span className="text-gold-500 font-mono text-xs">{`0${i + 1}`.slice(-2)}</span>
                                            {it.q}
                                        </span>
                                    </AccordionTrigger>
                                    <AccordionContent className="text-navy-600 text-base leading-relaxed pl-12 pb-6">
                                        {it.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
